"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));

var _grooveimagecommand = _interopRequireDefault(require("./grooveimagecommand"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * A plugin that converts custom attributes for elements that are wrapped in <figure> in the view.
 */
var GrooveImageEditing = /*#__PURE__*/function (_Plugin) {
  (0, _inherits2["default"])(GrooveImageEditing, _Plugin);

  var _super = _createSuper(GrooveImageEditing);

  function GrooveImageEditing() {
    (0, _classCallCheck2["default"])(this, GrooveImageEditing);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(GrooveImageEditing, [{
    key: "init",
    value: function init() {
      this.editor.config.define('grooveImagePluginConfig', {
        EDITOR_MAX_INLINE_IMAGE_SIZE: 100 * 1024,
        EDITOR_MAX_UPLOAD_SIZE: 20 * 1024 * 1024,
        // eslint-disable-next-line no-unused-vars
        onInlineImageTooLarge: function onInlineImageTooLarge(id, file) {},
        // eslint-disable-next-line no-unused-vars
        onFileTooLarge: function onFileTooLarge(func) {
          return [];
        }
      });
      this.editor.commands.add('grooveUploadImage', new _grooveimagecommand["default"](this.editor));
    }
    /**
     * Sets the conversion up and extends the table & image features schema.
     *
     * Schema extending must be done in the "afterInit()" call because plugins define their schema in "init()".
     */

  }, {
    key: "afterInit",
    value: function afterInit() {
      var editor = this.editor; // Define on which elements the CSS classes should be preserved:

      setupCustomClassConversion('imageBlock', 'imageInline', editor);
      editor.conversion["for"]('upcast').add(upcastCustomClasses('figure'), {
        priority: 'low'
      }); // Define custom attributes that should be preserved.

      setupCustomAttributeConversion('imageBlock', 'imageInline', 'customDataOriginalFilename', 'data-original-filename', editor);
      setupCustomAttributeConversion('imageBlock', 'imageInline', 'customImgClass', 'class', editor);
    }
  }]);
  return GrooveImageEditing;
}(_plugin["default"]);
/**
 * Sets up a conversion that preserves classes on <img> and <table> elements.
 */


exports["default"] = GrooveImageEditing;

function setupCustomClassConversion(viewElementName, modelElementName, editor) {
  // The 'customClass' attribute stores custom classes from the data in the model so that schema definitions allow this attribute.
  editor.model.schema.extend(modelElementName, {
    allowAttributes: ['customClass']
  }); // Defines upcast converters for the <img> and <table> elements with a "low" priority so they are run after the default converters.

  editor.conversion["for"]('upcast').add(upcastCustomClasses(viewElementName), {
    priority: 'low'
  }); // Defines downcast converters for a model element with a "low" priority so they are run after the default converters.
  // Use `downcastCustomClassesToFigure` if you want to keep your classes on <figure> element or `downcastCustomClassesToChild`
  // if you would like to keep your classes on a <figure> child element, i.e. <img>.

  editor.conversion["for"]('downcast').add(downcastCustomClassesToFigure(modelElementName), {
    priority: 'low'
  }); // editor.conversion
  //   .for('downcast')
  //   .add(downcastCustomClassesToChild(viewElementName, modelElementName), {
  //     priority: 'low',
  //   })
}
/**
 * Sets up a conversion for a custom attribute on the view elements contained inside a <figure>.
 *
 * This method:
 * - Adds proper schema rules.
 * - Adds an upcast converter.
 * - Adds a downcast converter.
 */


function setupCustomAttributeConversion(viewElementName, modelElementName, modelAttribute, viewAttribute, editor) {
  // Extends the schema to store an attribute in the model.
  // const modelAttribute = `custom${viewAttribute}`
  editor.model.schema.extend(modelElementName, {
    allowAttributes: [modelAttribute]
  });
  editor.conversion["for"]('upcast').add(upcastAttribute(viewElementName, viewAttribute, modelAttribute));
  editor.conversion["for"]('downcast').add(downcastAttribute(modelElementName, viewElementName, viewAttribute, modelAttribute));
}
/**
 * Creates an upcast converter that will pass all classes from the view element to the model element.
 */


function upcastCustomClasses(elementName) {
  return function (dispatcher) {
    return dispatcher.on("element:".concat(elementName), function (evt, data, conversionApi) {
      var viewItem = data.viewItem;
      var modelRange = data.modelRange;
      var modelElement = modelRange && modelRange.start.nodeAfter;

      if (!modelElement) {
        return;
      } // The upcast conversion picks up classes from the base element and from the <figure> element so it should be extensible.


      var currentAttributeValue = modelElement.getAttribute('customClass') || [];
      currentAttributeValue.push.apply(currentAttributeValue, (0, _toConsumableArray2["default"])(viewItem.getClassNames()));
      conversionApi.writer.setAttribute('customClass', currentAttributeValue, modelElement);
    });
  };
}
/**
 * Creates a downcast converter that adds classes defined in the `customClass` attribute to a <figure> element.
 *
 * This converter expects that the view element is nested in a <figure> element.
 */


function downcastCustomClassesToFigure(modelElementName) {
  return function (dispatcher) {
    return dispatcher.on("insert:".concat(modelElementName), function (evt, data, conversionApi) {
      var modelElement = data.item;
      var viewFigure = conversionApi.mapper.toViewElement(modelElement); // Adding undefined class will make image missing ck-widget_with-resizer class, which is used as resizing selector in the editor
      // We've changed to use grooveInsertImage instead of grooveUploadImage in the toolbar
      // so the customClass is undefined

      if (!viewFigure || !modelElement.getAttribute('customClass')) {
        return;
      } // The code below assumes that classes are set on the <figure> element.


      conversionApi.writer.addClass(modelElement.getAttribute('customClass'), viewFigure);
    });
  };
}
/**
 * Creates a downcast converter that adds classes defined in the `customClass` attribute to a <figure> child element.
 *
 * This converter expects that the view element is nested in a <figure> element.
 */
// eslint-disable-next-line no-unused-vars


function downcastCustomClassesToChild(viewElementName, modelElementName) {
  return function (dispatcher) {
    return dispatcher.on("insert:".concat(modelElementName), function (evt, data, conversionApi) {
      var modelElement = data.item;
      var viewFigure = conversionApi.mapper.toViewElement(modelElement);

      if (!viewFigure) {
        return;
      } // The code below assumes that classes are set on the element inside the <figure>.


      var viewElement = findViewChild(viewFigure, viewElementName, conversionApi);
      conversionApi.writer.addClass(modelElement.getAttribute('customClass'), viewElement);
    });
  };
}
/**
 * Helper method that searches for a given view element in all children of the model element.
 *
 * @param {module:engine/view/item~Item} viewElement
 * @param {String} viewElementName
 * @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
 * @return {module:engine/view/item~Item}
 */


function findViewChild(viewElement, viewElementName, conversionApi) {
  var viewChildren = Array.from(conversionApi.writer.createRangeIn(viewElement).getItems());
  return viewChildren.find(function (item) {
    return item.is('element', viewElementName);
  });
}
/**
 * Returns the custom attribute upcast converter.
 */


function upcastAttribute(viewElementName, viewAttribute, modelAttribute) {
  return function (dispatcher) {
    return dispatcher.on("element:".concat(viewElementName), function (evt, data, conversionApi) {
      var viewItem = data.viewItem;
      var modelRange = data.modelRange;
      var modelElement = modelRange && modelRange.start.nodeAfter;

      if (!modelElement) {
        return;
      }

      conversionApi.writer.setAttribute(modelAttribute, viewItem.getAttribute(viewAttribute), modelElement);
    });
  };
}
/**
 * Returns the custom attribute downcast converter.
 */


function downcastAttribute(modelElementName, viewElementName, viewAttribute, modelAttribute) {
  return function (dispatcher) {
    return dispatcher.on("insert:".concat(modelElementName), function (evt, data, conversionApi) {
      var modelElement = data.item;
      var viewFigure = conversionApi.mapper.toViewElement(modelElement);
      var viewElement = findViewChild(viewFigure, viewElementName, conversionApi);

      if (!viewElement) {
        return;
      }

      conversionApi.writer.setAttribute(viewAttribute, modelElement.getAttribute(modelAttribute), viewElement);
    });
  };
}
//# sourceMappingURL=grooveimageediting.js.map